import styled from 'styled-components';

export const Wrapper = styled.div`
  color: ${({ theme }) => theme.colors.black9};
  font-size: 12px;
  font-weight: 400;
  line-height: 20px;
`;
